const Mock = require('mockjs');

//消息信息
let messageobj=[];
for (var i = 0; i < 50; i++) {
    messageobj.push({
        id: Mock.Random.id(), // 身份证号
        rq: Mock.Random.datetime("yyyy-MM-dd"), 
        xxnr:Mock.Random.ctitle(15, 30),
        "ydzt|1":["未阅读","已阅读"],
    });
}
Mock.mock('/api/message','get',
{
    "status":200,
    "data":messageobj
})


//库存预警信息
let warningobj=[];
for (var i = 0; i < 50; i++) {
    warningobj.push({
        id: Mock.Random.id(), // 身份证号
        "wzlb|1":["产品","物资"],
        wzmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ccsl: Mock.Random.integer(1,50),
        yjz: Mock.Random.integer(1,50),
    });
}
Mock.mock('/api/warning','get',
{
    "status":200,
    "data":warningobj
})



//产品信息
let obj=[];
for (var i = 0; i < 50; i++) {
     obj.push({
        id: Mock.Random.id(), // 身份证号
        mc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        lhzbjwh: Mock.Random.ctitle(5, 10),
        gtfh: Mock.Random.ctitle(5, 10), 
        ccyq: Mock.Random.ctitle(5, 10),
        yjcz: Mock.Random.ctitle(5, 10),
        ytlb: Mock.Random.ctitle(5, 10),
        yslb: Mock.Random.ctitle(5, 10),
        bz: Mock.Random.ctitle(5, 10),
    });
}
Mock.mock('/api/product','get',
{
    "status":200,
    "data":obj
})



//原材料信息
let p_mobj=[];
for (var i = 0; i < 8; i++) {
    p_mobj.push({
        id: Mock.Random.id(), // 身份证号
        clmc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        pfb: "2:8"
    });
}
Mock.mock('/api/product_materials','get',{
    "status":200,
    "data":p_mobj
})



//产品包装桶信息
let product_package_mobj=[];
for (var i = 0; i < 8; i++) {
    product_package_mobj.push({
        id: Mock.Random.id(), // 身份证号
        bztmc: "包装桶_"+(i+1),
        dh: "20230101",
        "ggxh|1":["50Kg","100Kg","500Kg","1000Kg"],
        dw: "吨",
    });
}
Mock.mock('/api/product_package','get',{
    "status":200,
    "data":product_package_mobj
})


//原材料信息
let mobj=[];
for (var i = 0; i < 50; i++) {
    mobj.push({
        id: Mock.Random.id(), // 身份证号
        mc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        lhzbjwh: Mock.Random.ctitle(5, 10),
        gtfh: Mock.Random.ctitle(5, 10), 
        ccyq: Mock.Random.ctitle(5, 10),
        yjcz: Mock.Random.ctitle(5, 10),
        ytlb: Mock.Random.ctitle(5, 10),
        yslb: Mock.Random.ctitle(5, 10),
        bz: Mock.Random.ctitle(5, 10),
    });
}
Mock.mock('/api/materials','get',{
    "status":200,
    "data":mobj
})


//塑料桶信息
let pobj=[];
for (var i = 0; i < 50; i++) {
    pobj.push({
        id: Mock.Random.id(), // 身份证号
        mc: "塑料桶_"+(i+1),
        dh: "1001",
        ggxh: "50Kg/袋",
        dw: "吨",
        // "bztfl|1":["是成品包装桶","原材料包装桶"],
        bztfl:"分类"+parseInt((i/5+1)), 
        bz: Mock.Random.ctitle(5, 10),
    });
}
Mock.mock('/api/plastic','get',{
    "status":200,
    "data":pobj
})



//厂区物资
let fobj=[];
for (var i = 0; i < 10; i++) {
    fobj.push({
        id: Mock.Random.id(), 
        "cq|1":["一厂区","二厂区","三厂区"],
        lb:(parseInt(i/5+1))==1?"产品":"材料",
        "mc|1":["产品"+(i+1),"材料"+(i+1)],
        dh: "1001",
        ggxh: "50Kg/袋",
        dw: "吨",
        yjz:100,
    });
}
Mock.mock('/api/factory','get',{
    "status":200,
    "data":fobj
})


// 库房
Mock.mock('/api/storehouse','get',{
    "status":200,
    "data|6":[{
        "id|+1":1,
        "kfmc": "库房",
        "cq|1":["一厂区","二厂区","三厂区"]
    }]
})


// 库房物资
let smobj=[];
for (var i = 0; i < 20; i++) {
    smobj.push({
        id: Mock.Random.id(), 

        kfmc:"库房"+(parseInt(i/6+1)),
        lb:"产品类别"+(parseInt(i/3+1)),
        mc:"产品"+(parseInt(i/3+1)),

        dh: "1001",
        ggxh: "50Kg/袋",
        dw: "吨"
    });
}
Mock.mock('/api/warehousematerials','get',{
    "status":200,
    "data":smobj
})


// 库房显示屏
let spobj=[];
for (var i = 0; i < 5; i++) {
    spobj.push({
        id: Mock.Random.id(), 
        "xsplb|1":["库房外显示屏","库房内显示屏"],
        xspbh:"显示屏"+(i+1),
        mc:"显示屏"+(i+1),
        "lb|1":["产品","材料"],
        "wzmc|1":["产品"+(i+1),"材料"+(i+1)],
        dh: "1001",
        ggxh: "50Kg/袋",
        dw: "吨"
    });
}
Mock.mock('/api/warehousemonitor','get',{
    "status":200,
    "data":spobj
})


// 显示屏
Mock.mock('/api/monitor','get',{
    "status":200,
    "data|6":[{
        "id|+1":1,
        "name": "显示屏"
    }]
})



// 显示屏物资
let pmobj=[];
for (var i = 0; i < 20; i++) {
    pmobj.push({
        id: Mock.Random.id(), 
        kfmc:"库房"+(parseInt(i/6+1)),
        xspbh:"显示屏"+(parseInt(i/3+1)),
        xspmc:"显示屏"+(parseInt(i/3+1)),
        "lb|1":["产品","材料"],
        "wzmc|1":["产品"+(i+1),"材料"+(i+1)],
        dh: "1001",
        ggxh: "50Kg/袋",
        dw: "吨"
    });
}

Mock.mock('/api/monitorMaterials','get',{
    "status":200,
    "data":pmobj
})



//供应商信息
let sobj=[];
for (var i = 0; i < 50; i++) {
    sobj.push({
        id: Mock.Random.id(), 
        mc:"供应商"+(i+1),
        jc:"001_"+(i+1),
        dz:"@county(true)",
        lxr: "@cname",
        lxdh: /^1[34578]\d{9}$/, 
        bz: Mock.Random.ctitle(10, 15),
    });
}
Mock.mock('/api/supplier','get',{
    "status":200,
    "data":sobj
})


//井场信息
let wobj=[];
for (var i = 0; i < 50; i++) {
    wobj.push({
        id: Mock.Random.id(), 
        jh:"港01"+(i+1),
        dz:"@county(true)",
        lxr: "@cname",
        lxdh: /^1[34578]\d{9}$/, 
        bz: Mock.Random.ctitle(10, 15)
    });
}
Mock.mock('/api/wellsite','get',{
    "status":200,
    "data":wobj
})


//收货单位信息
let receiveobj=[];
for (var i = 0; i < 50; i++) {
    receiveobj.push({
        id: Mock.Random.id(), 
        mc:"收货单位"+(i+1),
        dz:"@county(true)",
        lxr: "@cname",
        lxdh: /^1[34578]\d{9}$/, 
        bz: Mock.Random.ctitle(10, 15)
    });
}
Mock.mock('/api/receive','get',{
    "status":200,
    "data":receiveobj
})




//原材料需求计划管理
let mpobj=[];
for (var i = 0; i < 50; i++) {
    mpobj.push({
        id: Mock.Random.id(), 
        xqjhdh:"港01"+(i+1),
        yqdhrq:Mock.Random.datetime("yyyy-MM-dd"),
        dhdz: "@county(true)",
        tbr: "@cname", 
        sqrq: Mock.Random.datetime("yyyy-MM-dd"), 
        tjrq: Mock.Random.datetime("yyyy-MM-dd"),  
        tjzt:"未提交",
        bz: Mock.Random.ctitle(10, 15)
    });
}
Mock.mock('/api/materialPlan','get',{
    "status":200,
    "data":mpobj
})

// Mock.mock('/api/materialPlan','get',require('./json/materialPlan'))
Mock.mock('/api/materialPlan_material','get',require('./json/materialPlanMaterial'))

//原材料采购订单管理
let mcobj=[];
for (var i = 0; i < 50; i++) {
    mcobj.push({
        id: Mock.Random.id(), 
        xdrq:Mock.Random.datetime("yyyy-MM-dd"),
        ddbh:"20230526_"+(i+1),
        ddmc: "双氧水H2O2采购单"+(i+1),
        ghcj: "厂家"+(i+1), 
        yqshrq: Mock.Random.datetime("yyyy-MM-dd"), 
        jhdd: "@county(true)",
        lxr: "@cname",
        lxdh: /^1[34578]\d{9}$/, 
        czzt: "编制中",  
        wczt:"未提交",
        bz: Mock.Random.ctitle(5, 10)
    });
}
Mock.mock('/api/materialPurchasePlan','get',
{
    "status":200,
    "data":mcobj
})
Mock.mock('/api/materialPurchasePlan_material','get',require('./json/materialPurchasePlanMaterial'))


//原材料采购订单审核
let mpcobj=[];
for (var i = 0; i < 50; i++) {
    mpcobj.push({
        id: Mock.Random.id(), 
        xdrq:Mock.Random.datetime("yyyy-MM-dd"),
        ddbh:"20230526_"+(i+1),
        ddmc: "双氧水H2O2采购单"+(i+1),
        ghcj: "厂家"+(i+1), 
        yqshrq: Mock.Random.datetime("yyyy-MM-dd"), 
        jhdd: "@county(true)",
        lxr: "@cname",
        lxdh: /^1[34578]\d{9}$/, 
        lrr: "@cname", 
        lrrq:Mock.Random.datetime("yyyy-MM-dd"),
        bz: Mock.Random.ctitle(5, 10)
    });
}
Mock.mock('/api/materialPurchaseCheck','get',
{
    "status":200,
    "data":mpcobj
})

let mpcdobj=[];
for (var i = 0; i < 50; i++) {
    mpcdobj.push({
        id: Mock.Random.id(), 
        xdrq:Mock.Random.datetime("yyyy-MM-dd"),
        ddbh:"20230526_"+(i+1),
        ddmc: "双氧水H2O2采购单"+(i+1),
        ghcj: "厂家"+(i+1), 
        yqshrq: Mock.Random.datetime("yyyy-MM-dd"), 
        jhdd: "@county(true)",
        lxr: "@cname",
        lxdh: /^1[34578]\d{9}$/, 
        shr: "@cname", 
        shrq:Mock.Random.datetime("yyyy-MM-dd"),
        bz: Mock.Random.ctitle(5, 10)
    });
}
Mock.mock('/api/materialPurchaseChecked','get',{
    "status":200,
    "data":mpcdobj
})


//原材料入库待复核
let mcheckobj=[];
for (var i = 0; i < 50; i++) {
    mcheckobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        ghcj:"厂家"+(i+1), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),  
    });
}
//待复核
Mock.mock('/api/material_check','get',{
    "status":200,
    "data":mcheckobj
})



//原材料入库已复核
let mcheckedobj=[];
for (var i = 0; i < 50; i++) {
    mcheckedobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        ghcj:"厂家"+(i+1), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/material_checked','get',{
    "status":200,
    "data":mcheckedobj
})


//原材料入库待审批
let mapprovalobj=[];
for (var i = 0; i < 50; i++) {
    mapprovalobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        ghcj:"厂家"+(i+1), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),  
    });
}
//待审批
Mock.mock('/api/material_approval','get',{
    "status":200,
    "data":mapprovalobj
})



//原材料入库已审批
let mapprovaledobj=[];
for (var i = 0; i < 50; i++) {
    mapprovaledobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        ghcj:"厂家"+(i+1), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已审批
Mock.mock('/api/material_approvaled','get',{
    "status":200,
    "data":mapprovaledobj
})



//原材料入库查看
let mviewdobj=[];
for (var i = 0; i < 50; i++) {
    mviewdobj.push({
        id: Mock.Random.id(), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        ghcj:"厂家"+parseInt((i/5+1)), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        "dyzt|1":["未打印","已打印"],
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//查看
Mock.mock('/api/material_view','get',{
    "status":200,
    "data":mviewdobj
})




//直达料入库待复核
let arriveobj=[];
for (var i = 0; i < 50; i++) {
    arriveobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        ghcj:"厂家"+(i+1), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),  
    });
}
//待复核
Mock.mock('/api/arrive_check','get',{
    "status":200,
    "data":arriveobj
})



//直达料入库已复核
let marriveedobj=[];
for (var i = 0; i < 50; i++) {
    marriveedobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        ghcj:"厂家"+(i+1), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/arrive_checked','get',{
    "status":200,
    "data":marriveedobj
})


//直达料入库待审批
let arrivepprovalobj=[];
for (var i = 0; i < 50; i++) {
    arrivepprovalobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        ghcj:"厂家"+(i+1), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),  
    });
}
//待审批
Mock.mock('/api/arrive_approval','get',{
    "status":200,
    "data":arrivepprovalobj
})



//直达料入库已审批
let arriveapprovaledobj=[];
for (var i = 0; i < 50; i++) {
    arriveapprovaledobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        ghcj:"厂家"+(i+1), 
        yclmc: "原材料_"+(i+1),
        bztmc: "包装桶_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已审批
Mock.mock('/api/arrive_approvaled','get',{
    "status":200,
    "data":arriveapprovaledobj
})


//直达料入库查看
let arriveviewobj=[];
for (var i = 0; i < 50; i++) {
    arriveviewobj.push({
        id: Mock.Random.id(), 

        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        ghcj:"厂家"+parseInt((i/5+1)), 

        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        "dyzt|1":["未打印","已打印"],
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已审批
Mock.mock('/api/arrive_view','get',{
    "status":200,
    "data":arriveviewobj
})


//产成品通知
let productnotifyobj=[];
for (var i = 0; i < 50; i++) {
    productnotifyobj.push({
        id: Mock.Random.id(), 
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        ccpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sl:Mock.Random.integer(1,50), 
        yclcj:"厂家"+(i+1), 
        jytzr:"@cname", 
        jytzrq:Mock.Random.datetime("yyyy-MM-dd"), 
        "jyjg|1":["","合格","不合格"],
        jyrq:Mock.Random.datetime("yyyy-MM-dd"), 
        "zt|1":["待通知质检","待反馈质检结果","已质检","待入库","待反馈质待提交复核检结果","待复核","待审批","已审批","报废待审批","已报废","补料待审批","已补料","已完成"],
        bz: Mock.Random.ctitle(5, 10),
        bhgyy:Mock.Random.ctitle(5, 10)
    });
}
//待复核
Mock.mock('/api/product_notify','get',{
    "status":200,
    "data":productnotifyobj
})


//产成品待复核
let productobj=[];
for (var i = 0; i < 50; i++) {
    productobj.push({
        id: Mock.Random.id(), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        ccpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        scsl: Mock.Random.integer(1,50),
        yclcj:"厂家"+(i+1), 
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),  
    });
}
//待复核
Mock.mock('/api/product_check','get',{
    "status":200,
    "data":productobj
})



//产成品已复核
let productedobj=[];
for (var i = 0; i < 50; i++) {
    productedobj.push({
        id: Mock.Random.id(), 
        rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        ccpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        scsl: Mock.Random.integer(1,50),
        yclcj:"厂家"+(i+1), 
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/product_checked','get',{
    "status":200,
    "data":productedobj
})


//产成品待审批
let productepprovalobj=[];
for (var i = 0; i < 50; i++) {
    productepprovalobj.push({
        id: Mock.Random.id(), 
        rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        ccpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        scsl: Mock.Random.integer(1,50),
        yclcj:"厂家"+(i+1), 
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),  
    });
}
//待审批
Mock.mock('/api/product_approval','get',{
    "status":200,
    "data":productepprovalobj
})



//产成品已审批
let productapprovaledobj=[];
for (var i = 0; i < 50; i++) {
    productapprovaledobj.push({
        id: Mock.Random.id(), 
        rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        ccpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        scsl: Mock.Random.integer(1,50),
        yclcj:"厂家"+(i+1), 
        sccj:"厂家"+(i+1), 
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已审批
Mock.mock('/api/product_approvaled','get',{
    "status":200,
    "data":productapprovaledobj
})


//产成品查看
let productviewobj=[];
for (var i = 0; i < 50; i++) {
    productviewobj.push({
        id: Mock.Random.id(), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        sccj:"厂家"+parseInt((i/5+1)), 
        ccpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        "dyzt|1":["未打印","已打印"],
        scsl: Mock.Random.integer(1,50), 
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已审批
Mock.mock('/api/product_view','get',{
    "status":200,
    "data":productviewobj
})


//提值增效入库登记
let qualityEfficiencyapplyobj=[];
for (var i = 0; i < 50; i++) {
    qualityEfficiencyapplyobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        sccj: "厂家_"+(i+1),
        "zzlb|1":["产成品","直达料"],
        "dyzt|1":["未打印","已打印"],
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),  
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),  
    });
}
//待复核
Mock.mock('/api/qualityEfficiency_apply','get',{
    "status":200,
    "data":qualityEfficiencyapplyobj
})



//生产领料申请
let pickapplyobj=[];
for (var i = 0; i < 50; i++) {
    pickapplyobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        sqrq:"2023-07-0"+(parseInt(i/10+1)),
        ccpmc: "产品_"+(i+1),
        bztmc: "包装桶_"+(i+1),
        scsl: Mock.Random.integer(1,50),
        jldw: "吨",
        jh:"井_"+(i+1),
        yclcj: "厂家_"+(i+1),
        fhmdd: "@county(true)",
        "zt|1":["待提交库房","待库房发料","待复核"],
        wlmc: "物资_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sqsl: Mock.Random.integer(1,50),
        czsl: Mock.Random.integer(1,50),
        bz: Mock.Random.ctitle(5, 10),
        sqr: "@cname",

    });
}
//待复核
Mock.mock('/api/pick_apply','get',{
    "status":200,
    "data":pickapplyobj
})


//发料单待审批
let pickapprovalobj=[];
for (var i = 0; i < 50; i++) {
    pickapprovalobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        flrq:"2023-07-0"+(parseInt(i/10+1)),
        cpmc: "产品_"+(i+1),
        scsl: Mock.Random.integer(1,50),
        flcj: "生产厂家"+(i+1),
        yclmc: "原材料"+(parseInt(i/5+1)),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        qls:Mock.Random.integer(1,50),
        sfs:Mock.Random.integer(1,50),
        ckck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        cksl: Mock.Random.integer(1,50)

    });
}
//待复核
Mock.mock('/api/pick_approval','get',{
    "status":200,
    "data":pickapprovalobj
})



//发料单已审批
let pickpprovaledobj=[];
for (var i = 0; i < 50; i++) {
    pickpprovaledobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        flrq:"2023-07-0"+(parseInt(i/10+1)),
        cpmc: "产品_"+(parseInt(i/10+1)),
        dh: "纯碱(Na2CO3)"+(parseInt(i/10+1)),
        scsl: 10+(parseInt(i/10+1)),
        yclmc: "原材料"+(parseInt(i/5+1)),
        dh: "纯碱(Na2CO3)"+(parseInt(i/5+1)),
        ggxh: "50Kg/袋"+(parseInt(i/5+1)),
        dw: "吨"+(parseInt(i/5+1)),
        qls:20+(parseInt(i/5+1)),
        sfs:10+(parseInt(i/5+1)),
        ckck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        cksl: Mock.Random.integer(1,50),
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/pick_approvaled','get',{
    "status":200,
    "data":pickpprovaledobj
})




//发料出库单查看
let pickviewdobj=[];
for (var i = 0; i < 50; i++) {
    pickviewdobj.push({
        id: Mock.Random.id(), 
        flrq:"2023-07-0"+(6-parseInt(i/10+1)),
        cpmc: "产品_"+(i+1),
        scsl:Mock.Random.integer(1,50),
        "dyzt|1":["未打印","已打印"],
        yclmc:"原材料"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",   
        ckck:"仓库"+(i+1),
        qls: Mock.Random.integer(1,50),
        sfs: Mock.Random.integer(1,50),
        fhck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        cksl: Mock.Random.integer(1,50),  
    });
}
//查看
Mock.mock('/api/pick_view','get',{
    "status":200,
    "data":pickviewdobj
})





//特殊用料待复核
let special_check_obj=[];
for (var i = 0; i < 50; i++) {
    special_check_obj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        flrq:"2023-07-0"+(parseInt(i/10+1)),
        lldw:"单位"+(i+1),
        llr:"@cname",
        "dyzt|1":["未打印","已打印"],
        yclmc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        qlsl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        ckck: "仓库_"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        cksl: Mock.Random.integer(1,50),  

    });
}
//待复核
Mock.mock('/api/special_check','get',{
    "status":200,
    "data":special_check_obj
})



//特殊用料待已复核
let special_checked_obj=[];
for (var i = 0; i < 50; i++) {
    special_checked_obj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        flrq:"2023-07-0"+(parseInt(i/10+1)),
        lldw:"单位"+(i+1),
        llr:"@cname",
        "dyzt|1":["未打印","已打印"],
        yclmc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        qlsl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        ckck: "仓库_"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        cksl: Mock.Random.integer(1,50),  
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),  

    });
}
//待复核
Mock.mock('/api/special_checked','get',{
    "status":200,
    "data":special_checked_obj
})






//产品提货申请
let outboundapplyobj=[];
for (var i = 0; i < 50; i++) {
    outboundapplyobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        sqrq:"2023-07-0"+(parseInt(i/10+1)),
        fhmdd: "@county(true)",
        "zt|1":["待提交库房","待库房发货","完成发货"],
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sqsl: Mock.Random.integer(1,50),
        yfsl: Mock.Random.integer(1,50),
        bz: Mock.Random.ctitle(5, 10),
        lxr: "@cname",
        sqr: "@cname",
        lxdh:/^1[34578]\d{9}$/, 
    });
}
//待复核
Mock.mock('/api/outbound_apply','get',{
    "status":200,
    "data":outboundapplyobj
})


//发货出库待复核
let outboundcheckobj=[];
for (var i = 0; i < 50; i++) {
    outboundcheckobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        fhrq:"2023-07-0"+(parseInt(i/10+1)),
        fhmdd: "@county(true)",
        yscph: "川F1367"+(i+1), 
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sqsl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        fhck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        fhsl: Mock.Random.integer(1,50),
    });
}
//待复核
Mock.mock('/api/outbound_check','get',{
    "status":200,
    "data":outboundcheckobj
})



//原材料入库已复核
let outboundcheckedobj=[];
for (var i = 0; i < 50; i++) {
    outboundcheckedobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        fhrq:"2023-07-0"+(parseInt(i/10+1)),
        fhmdd: "@county(true)",
        yscph: "川F1367"+(i+1), 
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sqsl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        fhck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        fhsl: Mock.Random.integer(1,50),
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/outbound_checked','get',{
    "status":200,
    "data":outboundcheckedobj
})


//原材料入库待审批
let outboundapprovalobj=[];
for (var i = 0; i < 50; i++) {
    outboundapprovalobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        fhrq:"2023-07-0"+(parseInt(i/10+1)),
        fhmdd: "@county(true)",
        yscph: "川F1367"+(i+1), 
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sqsl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        fhck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        fhsl: Mock.Random.integer(1,50),
    });
}
//待审批
Mock.mock('/api/outbound_approval','get',{
    "status":200,
    "data":outboundapprovalobj
})



//原材料入库已审批
let outboundapprovaledobj=[];
for (var i = 0; i < 50; i++) {
    outboundapprovaledobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        fhrq:"2023-07-0"+(parseInt(i/10+1)),
        fhmdd: "@county(true)",
        yscph: "川F1367"+(i+1), 
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sqsl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        ckck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        fhsl: Mock.Random.integer(1,50),
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已审批
Mock.mock('/api/outbound_approvaled','get',{
    "status":200,
    "data":outboundapprovaledobj
})


//发货出库单查看
let outboundviewdobj=[];
for (var i = 0; i < 50; i++) {
    outboundviewdobj.push({
        id: Mock.Random.id(), 
        fhrq:"2023-07-0"+(6-parseInt(i/10+1)),
        fhmdd: "@county(true)",
        yscph: "川F1367"+(i+1),  
        "dyzt|1":["未打印","已打印"],
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",   
        sqsl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        fhck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        fhsl: Mock.Random.integer(1,50), 
        bz: Mock.Random.ctitle(5, 10) 
    });
}
//查看
Mock.mock('/api/outbound_view','get',{
    "status":200,
    "data":outboundviewdobj
})



//井场退回产品管理待复核
let rcheckobj=[];
for (var i = 0; i < 50; i++) {
    rcheckobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        thjh:"生产井"+(i+1), 
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),  
    });
}
//待复核
Mock.mock('/api/refund_check','get',{
    "status":200,
    "data":rcheckobj
})



//井场退回产品管理已复核
let rcheckedobj=[];
for (var i = 0; i < 50; i++) {
    rcheckedobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        thjh:"生产井"+(i+1), 
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/refund_checked','get',{
    "status":200,
    "data":rcheckedobj
})



//井场退回产品管理待审批
let rapprovalobj=[];
for (var i = 0; i < 50; i++) {
    rapprovalobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        thjh:"生产井"+(i+1), 
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50),  
    });
}
//待复核
Mock.mock('/api/refund_approval','get',{
    "status":200,
    "data":rapprovalobj
})



//井场退回产品管理已审批
let rapprovaledobj=[];
for (var i = 0; i < 50; i++) {
    rapprovaledobj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        thjh:"生产井"+(i+1), 
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/refund_approvaled','get',{
    "status":200,
    "data":rapprovaledobj
})



//井场退回产品管理查看
let rviewdobj=[];
for (var i = 0; i < 50; i++) {
    rviewdobj.push({
        id: Mock.Random.id(), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        thjh:"生产井"+(i+1), 
        cpmc: "产品_"+(i+1),
        "dyzt|1":["未打印","已打印"],
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        shsl: Mock.Random.integer(1,50),
        rkck:"仓库"+(i+1),
        rksl: Mock.Random.integer(1,50),
        "bzxs|1":["袋装","桶装"],
        bzsl: Mock.Random.integer(1,50), 
        spr: "@cname",
        sprq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//查看
Mock.mock('/api/refund_view','get',{
    "status":200,
    "data":rviewdobj
})





//产品包装空桶回收管理 待复核
let recovery_check_obj=[];
for (var i = 0; i < 50; i++) {
    recovery_check_obj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        jh: "井_"+(i+1),
        bztmc: "包装桶_"+(i+1),    
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        hssl:Mock.Random.integer(1,50),    
        rkck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 

    });
}
//待复核
Mock.mock('/api/recovery_check','get',{
    "status":200,
    "data":recovery_check_obj
})



//产品包装空桶回收管理已复核
let recovery_checked_obj=[];
for (var i = 0; i < 50; i++) {
    recovery_checked_obj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        rkrq:"2023-07-0"+(parseInt(i/10+1)),
        jh: "井_"+(i+1),
        bztmc: "包装桶_"+(i+1),    
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        hssl:Mock.Random.integer(1,50),    
        rkck:"仓库"+(i+1),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/recovery_checked','get',{
    "status":200,
    "data":recovery_checked_obj
})



//产品包装桶报废复核 待复核
let discard_check_obj=[];
for (var i = 0; i < 50; i++) {
    discard_check_obj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        bfrq:"2023-07-0"+(parseInt(i/10+1)),
        bztmc: "包装桶_"+(i+1),    
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        bfsl:Mock.Random.integer(1,50),    
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        "xjt|1":["新桶","旧桶"],
        bz: Mock.Random.ctitle(5, 10) 
       

    });
}
//待复核
Mock.mock('/api/discard_check','get',{
    "status":200,
    "data":discard_check_obj
})




let discard_checked_obj=[];
for (var i = 0; i < 50; i++) {
    discard_checked_obj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        bfrq:"2023-07-0"+(parseInt(i/10+1)),
        bztmc: "包装桶_"+(i+1),    
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        bfsl:Mock.Random.integer(1,50),    
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        "xjt|1":["新桶","旧桶"],
        bz: Mock.Random.ctitle(5, 10),
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//已复核
Mock.mock('/api/discard_checked','get',{
    "status":200,
    "data":discard_checked_obj
})



//7.4.1.	物资转库待复核
let transfer_check_obj=[];
for (var i = 0; i < 50; i++) {
    transfer_check_obj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        zkrq:"2023-07-0"+(parseInt(i/10+1)),
        zcck: "仓库_"+(i+1),   
        zrck: "仓库_"+(i+1),  
        "dyzt|1":["未打印","已打印"],
        mc: "物资" +(i+1),   
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        zksl:Mock.Random.integer(1,50),    
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        "bzxs|1":["桶装","袋装"],
        bzsl:Mock.Random.integer(1,50),    
        bz: Mock.Random.ctitle(5, 10), 
    });
}
//复核
Mock.mock('/api/transfer_check','get',{
    "status":200,
    "data":transfer_check_obj
})


//7.4.1.	物资转库已复核
let transfer_checked_obj=[];
for (var i = 0; i < 50; i++) {
    transfer_checked_obj.push({
        id: Mock.Random.id(), 
        // rkrq:Mock.Random.datetime("yyyy-MM-dd"), 
        zkrq:"2023-07-0"+(parseInt(i/10+1)),
        zcck: "仓库_"+(i+1),   
        zrck: "仓库_"+(i+1),   
        mc: "物资" +(i+1),   
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        zksl:Mock.Random.integer(1,50),    
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        "bzxs|1":["桶装","袋装"],
        bzsl:Mock.Random.integer(1,50),    
        bz: Mock.Random.ctitle(5, 10), 
        fhr: "@cname",
        fhrq: Mock.Random.datetime("yyyy-MM-dd"),   
    });
}
//复核
Mock.mock('/api/transfer_checked','get',{
    "status":200,
    "data":transfer_checked_obj
})



//原材料质检管理管理
let mppobj=[];
for (var i = 0; i < 50; i++) {
    mppobj.push({
        id: Mock.Random.id(), 
        shrq:"2023-07-0"+(parseInt(i/10+1)),
        shcj:"厂家"+parseInt((i/5+1)), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        shsl: Mock.Random.integer(1,50),
        zjtzr: "@cname",
        zjtzrq: Mock.Random.datetime("yyyy-MM-dd"),  
    });
}
//待检验
Mock.mock('/api/materialquality_inspect','get',{
    "status":200,
    "data":mppobj
})


//原材料质检管理管理--已质检
let mpchekedobj=[];
for (var i = 0; i < 50; i++) {
    mpchekedobj.push({
        id: Mock.Random.id(), 
       
        shrq:"2023-07-0"+(6-parseInt(i/10+1)),
        shcj:"厂家"+parseInt((i/5+1)), 
        yclmc: "原材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        shsl: Mock.Random.integer(1,50),
        zjtzr: "@cname",
        zjtzrq: Mock.Random.datetime("yyyy-MM-dd"),  
        jyqrr: "@cname",
        jyrq: Mock.Random.datetime("yyyy-MM-dd"),  
    });
}
//待检验
Mock.mock('/api/materialquality_inspected','get',{
    "status":200,
    "data":mpchekedobj
})




//产成品质检管理管理
let producttobj=[];
for (var i = 0; i < 50; i++) {
    producttobj.push({
        id: Mock.Random.id(), 
        jytzrq:"2023-07-0"+(parseInt(i/10+1)),
        mc: "产品"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sjsl: Mock.Random.integer(1,50),
        ph:Mock.Random.datetime("yyyy-MM-dd"),
        yclcj:"厂家"+(i+1), 
        tzr: "@cname",
    });
}
//待检验
Mock.mock('/api/productquality_inspect','get',{
    "status":200,
    "data":producttobj
})


//产成品质检管理管理--已质检
let productchekedobj=[];
for (var i = 0; i < 50; i++) {
    productchekedobj.push({
        id: Mock.Random.id(), 

        jytzrq:"2023-07-0"+(6-parseInt(i/10+1)),
        mc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sjsl: Mock.Random.integer(1,50),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        yclcj:"厂家"+(i+1), 
        tzr: "@cname",
        "jyjg|1":["合格","不合格"],
        jyr: "@cname",
        jyrq: Mock.Random.datetime("yyyy-MM-dd"),  
    });
}
//待检验
Mock.mock('/api/productquality_inspected','get',{
    "status":200,
    "data":productchekedobj
})



// 财务结算
//原材料入库管理
let material_in_obj=[];
for (var i = 0; i < 50; i++) {
    material_in_obj.push({
        id: Mock.Random.id(), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        ghcj: "厂家_"+(i+1),
        rkck:"仓库"+(i+1), 
        jsrq:Mock.Random.datetime("yyyy-MM-dd"), 
        "dyzt|1":["未打印","已打印"],
        mc:"原材料"+(i+1), 
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sl: Mock.Random.integer(1,50),
        kgy: "@cname",
        fhr: "@cname",
        spr: "@cname",
        bz: Mock.Random.ctitle(5, 10)  
    });
}
//原材料入库管理
Mock.mock('/api/material_in','get',{
    "status":200,
    "data":material_in_obj
})

// 原材料明细
let material_detail_obj=[];
for (var i = 0; i < 5; i++) {
    material_detail_obj.push({
        id: Mock.Random.id(), 
        yclmc:"原材料"+(i+1), 
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        rksl: Mock.Random.integer(1,50),
        bz: Mock.Random.ctitle(3, 8)  
    });
}
//原材料入库管理
Mock.mock('/api/material_in_detail','get',{
    "status":200,
    "data":material_detail_obj
})


// 财务统计报表

// 原材料入库汇总表
let material_all_obj=[];
for (var i = 0; i < 50; i++) {
    material_all_obj.push({
        id: Mock.Random.id(), 
        ghdw: "单位_"+(i+1),
        yclmc:"原材料"+(i+1), 
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        q12sl:  Mock.Random.integer(1,50),
        b1rksl:Mock.Random.integer(1,50),
        b2rksl:Mock.Random.integer(1,50),
        b3rksl:Mock.Random.integer(1,50),
        b4rksl:Mock.Random.integer(1,50),
        b5rksl:Mock.Random.integer(1,50),
        b6rksl:Mock.Random.integer(1,50),
        b7rksl:Mock.Random.integer(1,50),
        b8rksl:Mock.Random.integer(1,50),
        b9rksl:Mock.Random.integer(1,50),
        b10rksl:Mock.Random.integer(1,50),
        b11rksl:Mock.Random.integer(1,50),
        b12rksl:Mock.Random.integer(1,50),
        b1jssl:Mock.Random.integer(1,50),
        b2jssl:Mock.Random.integer(1,50),
        b3jssl:Mock.Random.integer(1,50),
        b4jssl:Mock.Random.integer(1,50),
        b5jssl:Mock.Random.integer(1,50),
        b6jssl:Mock.Random.integer(1,50),
        b7jssl:Mock.Random.integer(1,50),
        b8jssl:Mock.Random.integer(1,50),
        b9jssl:Mock.Random.integer(1,50),
        b10jssl:Mock.Random.integer(1,50),
        b11jssl:Mock.Random.integer(1,50),
        b12jssl:Mock.Random.integer(1,50),
        wjssl: Mock.Random.integer(1,50),
    });
}
//原材料入库管理
Mock.mock('/api/material_all','get',{
    "status":200,
    "data":material_all_obj
})



//原材料发料明细
let materials_send_detail=[];
for (var i = 0; i < 50; i++) {
    materials_send_detail.push({
        id: Mock.Random.id(), 
        rq:"2023-07-0"+(6-parseInt(i/10+1)),
        mc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sl: Mock.Random.integer(1,50),
        cj: "厂家"+(i+1),
        dycp: "产品"+(i+1),
        dycpsl: Mock.Random.integer(1,50),
        bz: Mock.Random.ctitle(3, 10)   
        
    });
}
//原材料发料明细
Mock.mock('/api/materials_send_detail','get',{
    "status":200,
    "data":materials_send_detail
})



//原材料收发存统计表
let product_self_detail=[];
for (var i = 0; i < 50; i++) {
    product_self_detail.push({
        id: Mock.Random.id(), 
        rq:"2023-07-0"+(6-parseInt(i/10+1)),
        mc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sl: Mock.Random.integer(1,50),
        sccj: "厂家"+(i+1),
        bz: Mock.Random.ctitle(3, 10)         
    });
}
//原材料收发存统计表
Mock.mock('/api/product_self_detail','get',{
    "status":200,
    "data":product_self_detail
})

//产品生产明细
let materials_stock_all=[];
for (var i = 0; i < 50; i++) {
    materials_stock_all.push({
        id: Mock.Random.id(), 
        gys: "供应商"+(i+1),
        mc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        qcsl: Mock.Random.integer(1,50),
        rksl: Mock.Random.integer(1,50),
        cksl: Mock.Random.integer(1,50),
        jcsl: Mock.Random.integer(1,50),        
    });
}
//产品生产明细
Mock.mock('/api/materials_stock_all','get',{
    "status":200,
    "data":materials_stock_all
})


//9.5.5.	产品发料明细
let product_send_detail=[];
for (var i = 0; i < 50; i++) {
    product_send_detail.push({
        id: Mock.Random.id(), 
        rq:"2023-07-0"+(6-parseInt(i/10+1)),
        mc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sl: Mock.Random.integer(1,50),
        ghdw: "供货单位"+(i+1),
        jcmc: "项目"+(i+1),
        xmmc: "供货单位"+(i+1),
        bz: Mock.Random.ctitle(3, 10)         
    });
}
//原材料收发存统计表
Mock.mock('/api/product_send_detail','get',{
    "status":200,
    "data":product_send_detail
})



//9.5.6.	产品进出库统计
let product_stock_all=[];
for (var i = 0; i < 50; i++) {
    product_stock_all.push({
        id: Mock.Random.id(), 
        mc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        gys: "供应商_"+(i+1),
        qcsl: Mock.Random.integer(1,50),
        rksl: Mock.Random.integer(1,50),
        cksl: Mock.Random.integer(1,50),
        jcsl: Mock.Random.integer(1,50),         
    });
}
//产品进出库统计
Mock.mock('/api/product_stock_all','get',{
    "status":200,
    "data":product_stock_all
})





//原材料入库明细（台账）
let materials_detail=[];
for (var i = 0; i < 50; i++) {
    materials_detail.push({
        id: Mock.Random.id(), 
        rkrq:"2023-07-0"+(6-parseInt(i/10+1)),
        yclmc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        rksl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        ph:Mock.Random.datetime("yyyy-MM-dd"), 
        ghcj: "厂家"+(i+1),
    });
}
//原材料入库明细（台账）
Mock.mock('/api/materials_detail','get',{
    "status":200,
    "data":materials_detail
})



//生产领料发料明细（台账）
let pick_detail=[];
for (var i = 0; i < 50; i++) {
    pick_detail.push({
        id: Mock.Random.id(), 
        flrq:"2023-07-0"+(6-parseInt(i/10+1)),
        yclmc: "材料_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        qlsl: Mock.Random.integer(1,50),
        sfsl: Mock.Random.integer(1,50),
        ghcj: "厂家"+(i+1),
    });
}
//仓库物资年报
Mock.mock('/api/pick_detail','get',{
    "status":200,
    "data":pick_detail
})

//产品发货明细表（台账）
let send_detail=[];
for (var i = 0; i < 50; i++) {
    send_detail.push({
        id: Mock.Random.id(), 
        fhrq:"2023-07-0"+(6-parseInt(i/10+1)),
        shdw: "单位"+(i+1),
        cpmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sl: Mock.Random.integer(1,50),
        sccj: "厂家"+(i+1),
    });
}
//产品发货明细表（台账）
Mock.mock('/api/send_detail','get',{
    "status":200,
    "data":send_detail
})

//产品包装桶回收入库明细（台账）
let package_detail=[];
for (var i = 0; i < 50; i++) {
    package_detail.push({
        id: Mock.Random.id(), 
        hsrq:"2023-07-0"+(6-parseInt(i/10+1)),
        jh: "井"+(i+1),
        mc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        sl: Mock.Random.integer(1,50),
    });
}
//仓库物资年报
Mock.mock('/api/package_detail','get',{
    "status":200,
    "data":package_detail
})



//仓库物资年报
let material_year_report=[];
for (var i = 0; i < 50; i++) {
    material_year_report.push({
        id: Mock.Random.id(), 
        wzmc: "产品_"+(i+1),
        dh: "纯碱(Na2CO3)",
        ggxh: "50Kg/袋",
        dw: "吨",
        qcsl: Mock.Random.integer(1,50),
        cksl: Mock.Random.integer(1,50),
        rksl: Mock.Random.integer(1,50),
        thsl: Mock.Random.integer(1,50),
        zrsl: Mock.Random.integer(1,50),
        zcsl: Mock.Random.integer(1,50),
        bfsl: Mock.Random.integer(1,50),
        pdtzsl: Mock.Random.integer(1,50),
        qmsl: Mock.Random.integer(1,50),
    });
}
//仓库物资年报
Mock.mock('/api/material_year','get',{
    "status":200,
    "data":material_year_report
})



// WEBPACK FOOTER //
// ./src/mock/index.js